import { ArrowPathIcon, CheckIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";

type LogRowProps = {
  active: boolean;
  completed: boolean;
  detail?: string | null;
  error?: boolean;
  loading?: boolean;
  onClick: () => void;
  title: string;
};

export default function LogRow({ active, completed, detail, error, loading, onClick, title }: LogRowProps) {
  return (
    <button
      type="button"
      className={`group flex w-full cursor-pointer items-start text-left ${!active && !completed ? "text-gray-400" : ""}`}
      onClick={onClick}
    >
      <span className={logIconClass(active, completed, Boolean(error))}>
        <LogIcon active={active} completed={completed} error={Boolean(error)} loading={Boolean(loading)} />
      </span>
      <span className="flex-1">
        <span
          className={`text-sm font-medium group-hover:underline ${error ? "text-error" : active ? "text-primary" : "text-gray-700"}`}
        >
          {title}
        </span>
        {detail ? (
          <span className={`mt-1 block text-xs ${error ? "text-error" : "text-gray-500"}`}>{detail}</span>
        ) : null}
      </span>
    </button>
  );
}

function logIconClass(active: boolean, completed: boolean, error: boolean) {
  const base = "mr-3 mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-xs";

  if (error) {
    return `${base} bg-error-light text-error`;
  }

  if (active) {
    return `${base} bg-primary text-white`;
  }

  if (completed) {
    return `${base} bg-green-500 text-white`;
  }

  return `${base} border-2 border-gray-300`;
}

function LogIcon({
  active,
  completed,
  error,
  loading,
}: {
  active: boolean;
  completed: boolean;
  error: boolean;
  loading: boolean;
}) {
  if (error) {
    return <XMarkIcon className="h-3 w-3" aria-hidden="true" />;
  }

  if (active && loading) {
    return <ArrowPathIcon className="h-3 w-3 animate-spin" aria-hidden="true" />;
  }

  if (active) {
    return <ChevronRightIcon className="h-3 w-3" aria-hidden="true" />;
  }

  if (completed) {
    return <CheckIcon className="h-3 w-3" aria-hidden="true" />;
  }

  return null;
}
